import { Controller } from "@hotwired/stimulus"
import { parse } from "postcss"

// Connects to data-controller="campaign"
export default class extends Controller {
  static targets = ["platform", "kind", "link", "linkExample", "quantity", "price", "kindPrice", "runs", "remarks"]
  static values = { prices: Array }

  connect() {
    this.price_per_one = 0
  }

  selectPlatform(event) {
    if (event.currentTarget.value) {
      this.kindTarget.disabled = false

      this.kindTarget.querySelectorAll('option').forEach((option) => {
        if (option.value != "")
          option.remove()
      })

      this.pricesValue.forEach((price) => {
        if (price.platform == event.currentTarget.value) {
          const formattedAmount = Number(price.amount).toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 })
          this.kindTarget.innerHTML += `<option value="${price.kind}">${price.kind_name}: ${formattedAmount} ${this.element.dataset.currency}</option>`
        }
      })
    } else {
      this.kindTarget.disabled = true
    }

    this.kindTarget.value = ""
    this.linkExampleTarget.innerHTML = ""
    this.quantityTarget.value = ""
    this.quantityTarget.disabled = true
    this.priceTarget.value = ""
    this.kindPriceTarget.textContent = ""
  }

  selectKind(event) {
    if (event.currentTarget.value) {
      this.selectedPlatformAndKind = this.pricesValue.find(price => price.platform == this.platformTarget.value && price.kind == event.currentTarget.value)

      // link example
      this.linkExampleTarget.innerHTML = this.selectedPlatformAndKind.link

      this.price_per_one = this.selectedPlatformAndKind.amount
      if (this.quantityTarget.value) {
        this.priceTarget.value = this.calculateTotal(this.quantityTarget.value)
      }

      const amountPerOne = Number(this.price_per_one).toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 })
      this.kindPriceTarget.textContent = `1${this.selectedPlatformAndKind.kind_name}あたり${amountPerOne} ${this.element.dataset.currency}消費します`

      this.quantityTarget.disabled = false
    } else {
      this.linkExampleTarget.innerHTML = ""

      this.price_per_one = 0
      this.quantityTarget.value = ""
      this.quantityTarget.disabled = true
      this.priceTarget.value = ""
      this.kindPriceTarget.textContent = ""
    }
  }

  changeQuantity(event) {
    this.priceTarget.value = this.calculateTotal(event.currentTarget.value)
  }

  calculateTotal(quantity) {
    const numericQuantity = Number(quantity) || 0
    return (this.price_per_one * numericQuantity).toFixed(1)
  }

  afterSubmit(event) {
    if (!event.detail.success) return

    if (!this.platformTarget.value || !this.kindTarget.value) return

    this.linkTarget.value = ""
    this.quantityTarget.value = ""
    this.priceTarget.value = ""

    if (this.hasRunsTarget) {
      this.runsTarget.value = ""
    }

    if (this.hasRemarksTarget) {
      this.remarksTarget.value = ""
    }

    this.quantityTarget.disabled = false

    if (this.hasLinkTarget) {
      window.requestAnimationFrame(() => {
        this.linkTarget.focus()
      })
    }
  }
}
